export default __webpack_public_path__ + "static/media/pots.13ec1605.jpg";